import { render, staticRenderFns } from "./UpdateNetwork.vue?vue&type=template&id=5e28b542&"
import script from "./UpdateNetwork.vue?vue&type=script&lang=js&"
export * from "./UpdateNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports